var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.002,
    height: 46.002,
    viewBox: "0 0 46.002 46.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-7470,19812a22.855,22.855,0,0,1-8.954-1.809,22.9,22.9,0,0,1-7.311-4.928,22.919,22.919,0,0,1-4.929-7.311A22.86,22.86,0,0,1-7493,19789a22.86,22.86,0,0,1,1.808-8.953,22.912,22.912,0,0,1,4.929-7.312,22.9,22.9,0,0,1,7.311-4.928A22.855,22.855,0,0,1-7470,19766a22.852,22.852,0,0,1,8.953,1.809,22.88,22.88,0,0,1,7.311,4.928,22.912,22.912,0,0,1,4.929,7.313A22.86,22.86,0,0,1-7447,19789a22.86,22.86,0,0,1-1.808,8.953,22.919,22.919,0,0,1-4.929,7.311,22.88,22.88,0,0,1-7.311,4.928A22.852,22.852,0,0,1-7470,19812Zm-2.378-30.547a3.067,3.067,0,0,0-2.089.838,2.961,2.961,0,0,0-.922,2.17v9.078a2.961,2.961,0,0,0,.922,2.17,3.069,3.069,0,0,0,2.09.838,2.958,2.958,0,0,0,1.746-.576l6.265-4.539a2.967,2.967,0,0,0,1.242-2.428,2.979,2.979,0,0,0-1.242-2.436l-6.265-4.539A2.968,2.968,0,0,0-7472.379,19781.453Z",
    transform: "translate(7493.002 -19765.998)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconWhite);
export default __webpack_public_path__ + "static/media/videoIconWhite.3ad35e5eefdf860d1aca7503063d086f.svg";
export { ForwardRef as ReactComponent };